// ============================================
// ENVIRONMENT WORKFLOW CONTROLLER (Complete with Snapshot System)
// Location: profile/tabs/environment/environment-workflow-controller.js
// ============================================

angular.module('bizmetryApp').controller('EnvWorkflowViewerController', function (
    $scope, $rootScope, $timeout, $mdDialog, $mdToast, $q,
    ProfileService, dialogService, ReferenceDataService, TemplateInstanceService
) {

    console.log('🎨 EnvironmentWorkflowController initialized');

    // ============================================
    // INICIALIZACIÓN
    // ============================================

    $scope.workflowEditMode = false;
    $scope.workflowHasChanges = false;
    $scope.sortedEnvironments = [];
    $scope.originalEnvironments = [];
    $scope.availableTemplates = [];
    $scope.envTypes = [];
    $scope.draggedIndex = null;
    $scope.workflowError = null;
    $scope.assignmentChecksPending = 0;

    // ============================================
    // ✅ ERROR/WARNING BANNER SYSTEM
    // ============================================

    $scope.showWorkflowError = function (message, type) {
        $scope.workflowError = {
            message: message,
            type: type || 'error', // 'error' or 'warning'
            timestamp: Date.now()
        };

        console.error('❌ Workflow error:', message);
    };

    $scope.hideWorkflowError = function () {
        $scope.workflowError = null;
    };

    // Auto-hide después de 8 segundos
    $scope.$watch('workflowError', function (error) {
        if (error) {
            $timeout(function () {
                if ($scope.workflowError && $scope.workflowError.timestamp === error.timestamp) {
                    $scope.hideWorkflowError();
                }
            }, 8000);
        }
    });

    // ============================================
    // CARGAR DATOS INICIALES
    // ============================================

    $scope.loadInitialData = function () {
        $scope.loadEnvironmentTypes();
        $scope.loadAvailableTemplates();
        $scope.sortEnvironmentsBySequence();
        $scope.refreshAgentStatuses();
    };

    // ============================================
    // ESTADO DEL AGENTE (fresco del backend)
    // ============================================
    // $scope.profile es la copia cargada al abrir el profile: el estado de los agentes cambia
    // después (agent-ms lo actualiza en el profile). Se relee el profile y se copian SÓLO los
    // campos del agente, sin tocar lo que el usuario esté editando.

    var AGENT_FIELDS = ['agent_status', 'agent_id', 'agent_last_syncup_ts'];
    var agentStatusSeq = 0;

    function applyAgentFields(environments, freshById) {
        var changed = false;
        (environments || []).forEach(function (env) {
            var fresh = env && env.id ? freshById[env.id] : null;
            if (!fresh) return;
            AGENT_FIELDS.forEach(function (field) {
                if (fresh[field] !== undefined && env[field] !== fresh[field]) {
                    env[field] = fresh[field];
                    changed = true;
                }
            });
        });
        return changed;
    }

    $scope.refreshAgentStatuses = function () {
        if (!$scope.profile || !$scope.profile.id) return;
        var profileId = $scope.profile.id;
        var seq = ++agentStatusSeq;

        ProfileService.getProfileById(profileId)
            .then(function (response) {
                if (seq !== agentStatusSeq || !$scope.profile || $scope.profile.id !== profileId) return;

                var data = response.data || {};
                var freshEnvs = data.environments || (data.profileData && data.profileData.environments) || [];
                var freshById = {};
                freshEnvs.forEach(function (env) { if (env && env.id) freshById[env.id] = env; });

                var changed = applyAgentFields($scope.sortedEnvironments, freshById);
                // El snapshot de edición también guarda agent_status: se actualiza igual para que
                // el refresco no cuente como un cambio sin salvar.
                applyAgentFields($scope.originalEnvironments, freshById);

                // Fuera de edición se propaga al profile raíz (su $watch re-ordena desde ahí). En
                // edición no: ese $watch reconstruiría la lista y perdería los cambios sin salvar.
                if (!$scope.workflowEditMode) {
                    applyAgentFields($scope.profile.environments, freshById);
                }

                if (changed) {
                    console.log('🔄 Agent statuses refreshed from backend');
                }
            })
            .catch(function (error) {
                console.error('❌ Error refreshing agent statuses:', error);
            });
    };

    $scope.loadEnvironmentTypes = function () {
        ReferenceDataService.getReferenceData('ENVIRONMENT_TYPE')
            .then(function (response) {
                $scope.envTypes = response.data || [];
                $scope.computeFlowDiagram(); // ← faltaba esta línea
                console.log("✅ Environment types loaded:", $scope.envTypes);
            })
            .catch(function (error) {
                console.error('❌ Error loading environment types:', error);
                $scope.envTypes = [];
            });
    };

    $scope.computeFlowDiagram = function () {
        var COLS = 8;
        var spacingX = 110;
        var spacingY = 120;
        var paddingX = 55;
        var paddingY = 55;
        var r = 34;

        $scope.flowNodes = ($scope.envTypes || []).slice().sort(function (a, b) {
            return a.refObjectId - b.refObjectId;
        });

        var nodes = $scope.flowNodes;

        nodes.forEach(function (node, i) {
            var row = Math.floor(i / COLS);
            var col = i % COLS;
            var isEvenRow = row % 2 === 0;
            var effectiveCol = isEvenRow ? col : (COLS - 1 - col);

            node._flowX = paddingX + effectiveCol * spacingX;
            node._flowY = paddingY + row * spacingY;
            node._row = row;
            node._isEvenRow = isEvenRow;
        });

        var numRows = Math.ceil(nodes.length / COLS);
        $scope.flowDiagramWidth = paddingX * 2 + (Math.min(nodes.length, COLS) - 1) * spacingX;
        $scope.flowDiagramHeight = paddingY * 2 + (numRows - 1) * spacingY;
        $scope.flowDiagramR = r;

        $scope.flowDiagramArrows = [];

        for (var i = 0; i < nodes.length - 1; i++) {
            var curr = nodes[i];
            var next = nodes[i + 1];
            var currRow = Math.floor(i / COLS);
            var nextRow = Math.floor((i + 1) / COLS);

            if (currRow === nextRow) {
                // Flecha horizontal dentro de la misma fila
                var goingRight = curr._isEvenRow;
                $scope.flowDiagramArrows.push({
                    type: 'line',
                    x1: curr._flowX + (goingRight ? (r + 4) : -(r + 4)),
                    y1: curr._flowY,
                    x2: next._flowX + (goingRight ? -(r + 4) : (r + 4)),
                    y2: next._flowY
                });
            } else {
                // Flecha vertical entre filas (baja)
                $scope.flowDiagramArrows.push({
                    type: 'line',
                    x1: curr._flowX,
                    y1: curr._flowY + r + 4,
                    x2: next._flowX,
                    y2: next._flowY - r - 4
                });
            }
        }
    };
    $scope.loadAvailableTemplates = function () {
        if (!$scope.profile || !$scope.profile.id) return;

        ProfileService.getTemplateInstancesByProfile($scope.profile.id, 'PUBLISHED')
            .then(function (response) {
                $scope.availableTemplates = response.data || [];
                console.log('✅ Available templates loaded (PUBLISHED only):', $scope.availableTemplates.length);
                _syncTemplateStatusInEnvironments();  // ← NEW
            })
            .catch(function (error) {
                console.error('Error loading templates:', error);
                $scope.availableTemplates = [];
            });
    };

    function _syncTemplateStatusInEnvironments() {
        if (!$scope.sortedEnvironments || !$scope.availableTemplates) return;

        var changed = false;
        $scope.sortedEnvironments.forEach(function (env) {
            if (!env.templateInstanceId) return;

            var fresh = $scope.availableTemplates.find(function (t) {
                return t.id === env.templateInstanceId;
            });

            if (fresh) {
                env.templateInstanceStatus = fresh.templateStatus;
                env.templateInstanceVersion = fresh.templateVersion;
                env.selectedTemplateId = fresh.id;
                changed = true;
            }
        });

        if (changed) {
            // Propagar también al profile raíz para que quede consistente
            $scope.profile.environments = angular.copy($scope.sortedEnvironments);
            console.log('✅ Template statuses synced in sortedEnvironments');
        }
    }

    // ============================================
    // ORDENAR ENVIRONMENTS POR SECUENCIA
    // ============================================

    $scope.sortEnvironmentsBySequence = function () {
        if (!$scope.profile || !$scope.profile.environments) {
            $scope.sortedEnvironments = [];
            return;
        }

        $scope.sortedEnvironments = angular.copy($scope.profile.environments)
            .sort(function (a, b) {
                return (a.envSequence || 0) - (b.envSequence || 0);
            });

        $scope.sortedEnvironments.forEach(function (env) {
            env.selectedTemplateId = env.templateInstanceId || null;
        });

        $scope.updateAllSequences();

        console.log('📊 Environments sorted by sequence:', $scope.sortedEnvironments.length);
    };

    // ============================================
    // ACTUALIZAR SECUENCIAS
    // ============================================

    $scope.updateAllSequences = function () {
        $scope.sortedEnvironments.forEach(function (env, index) {
            env.envSequence = index;
        });

        console.log('🔢 Sequences updated:',
            $scope.sortedEnvironments.map(function (e) {
                return e.name + '=' + e.envSequence;
            }).join(', ')
        );
    };

    // ============================================
    // ✅ SNAPSHOT SYSTEM FOR CHANGE DETECTION
    // ============================================

    // Crear snapshot normalizado para comparación
    function createEnvironmentSnapshot(environments) {
        if (!environments) return [];

        return environments.map(function (env) {
            return {
                id: env.id,
                name: env.name,
                description: env.description,
                envType: env.envType,
                envTypeId: env.envTypeId,
                isEnabled: env.isEnabled,
                envSequence: env.envSequence,
                templateInstanceId: env.templateInstanceId || null,
                templateInstanceStatus: env.templateInstanceStatus || null,
                templateInstanceVersion: env.templateInstanceVersion || null,
                selectedTemplateId: env.selectedTemplateId || null,
                agent_status: env.agent_status || null,   // ✅ agregar
                agent_id: env.agent_id || null             // ✅ agregar
            };
        });
    }

    // Comparar estado actual vs snapshot original
    function hasWorkflowChanges() {
        if (!$scope.originalEnvironments || !$scope.sortedEnvironments) {
            return false;
        }

        // Verificar si cambió la cantidad de environments
        if ($scope.originalEnvironments.length !== $scope.sortedEnvironments.length) {
            console.log('🔍 Change detected: Different number of environments');
            return true;
        }

        // Crear snapshots normalizados para comparación
        var currentSnapshot = createEnvironmentSnapshot($scope.sortedEnvironments);

        // Comparar cada environment
        for (var i = 0; i < currentSnapshot.length; i++) {
            var current = currentSnapshot[i];
            var original = $scope.originalEnvironments[i];

            // Comparar todos los campos relevantes
            if (current.id !== original.id ||
                current.name !== original.name ||
                current.description !== original.description ||
                current.envType !== original.envType ||
                current.envTypeId !== original.envTypeId ||
                current.isEnabled !== original.isEnabled ||
                current.envSequence !== original.envSequence ||
                current.templateInstanceId !== original.templateInstanceId ||
                current.templateInstanceStatus !== original.templateInstanceStatus ||
                current.templateInstanceVersion !== original.templateInstanceVersion ||
                current.selectedTemplateId !== original.selectedTemplateId) {

                console.log('🔍 Change detected in environment:', current.name, {
                    field: 'multiple',
                    original: original,
                    current: current
                });

                return true;
            }
        }

        console.log('✅ No changes detected');
        return false;
    }

    // Actualizar flag de cambios basándose en comparación
    function updateWorkflowChangesFlag() {
        var hasChanges = hasWorkflowChanges();

        if ($scope.workflowHasChanges !== hasChanges) {
            console.log('🔄 Workflow changes flag updated:', $scope.workflowHasChanges, '→', hasChanges);
            $scope.workflowHasChanges = hasChanges;
        }
    }

    $scope.markWorkflowChanged = function () {
        // En lugar de solo poner true, verificar si realmente hay cambios
        $timeout(function () {
            updateWorkflowChangesFlag();
        }, 0);
    };

    // ============================================
    // MODO EDICIÓN
    // ============================================

    $scope.enterWorkflowEditMode = function () {
        console.log('✏️ Entering workflow edit mode');

        $scope.workflowEditMode = true;
        $scope.workflowHasChanges = false;

        $scope.updateAllSequences();

        // ✅ Crear snapshot profundo del estado inicial
        $scope.originalEnvironments = createEnvironmentSnapshot($scope.sortedEnvironments);

        console.log('📸 Snapshot created:', $scope.originalEnvironments.length, 'environments');
    };

    $scope.cancelWorkflowEdit = function () {
        // Si no hay cambios, cancelar directamente sin molestar al usuario
        if (!$scope.workflowHasChanges) {
            $scope.sortedEnvironments = angular.copy($scope.originalEnvironments);
            $scope.workflowEditMode = false;
            $scope.workflowHasChanges = false;
            return;
        }

        // Hay cambios pendientes → pedir confirmación
        dialogService.showDecisionDialog(
            'Discard Changes',
            'You have unsaved changes in the release pipeline.<br><br>' +
            'If you continue, <strong>all modifications will be permanently lost</strong> ' +
            'and the pipeline will revert to its last saved state.<br><br>' +
            'Are you sure you want to discard all changes?'
        ).then(function (decision) {
            if (decision === 'proceed') {
                console.log('❌ Cancelling workflow edit — discarding all changes');
                $scope.sortedEnvironments = angular.copy($scope.originalEnvironments);
                $scope.workflowEditMode = false;
                $scope.workflowHasChanges = false;
                $scope.hideWorkflowError();
            }
            // Si el usuario cierra el dialog sin confirmar, no hacemos nada
        });
    };
    // ============================================
    // VALIDACIÓN
    // ============================================

    $scope.isWorkflowValid = function () {
        var allValid = $scope.sortedEnvironments.every(function (env) {
            return env.name && env.name.trim().length > 0 &&
                env.envType &&
                $scope.isTemplateValidForEnv(env);
        });

        return allValid;
    };

    $scope.isTemplateValidForEnv = function (env) {
        // ✅ Si no hay template asignado, es válido
        if (!env.selectedTemplateId && !env.templateInstanceId) {
            return true;
        }

        // ✅ Buscar template por selectedTemplateId O templateInstanceId (fallback)
        var template = $scope.availableTemplates.find(function (t) {
            return t.id === env.selectedTemplateId || t.id === env.templateInstanceId;
        });

        if (!template) {
            console.warn('⚠️ Template not found for env:', env.name);
            return false;
        }

        // Only PUBLISHED templates are valid for any environment type.
        return template.templateStatus === 'PUBLISHED';
    };

    $scope.canEnableEnvironment = function (env) {
        // Si NO tiene template → NO puede habilitar
        if (!env.selectedTemplateId && !env.templateInstanceId) {
            return false;
        }

        var template = $scope.availableTemplates.find(function (t) {
            return t.id === env.selectedTemplateId || t.id === env.templateInstanceId;
        });

        if (!template) {
            return false;
        }

        // ✅ Solo PUBLISHED puede estar enabled
        return template.templateStatus === 'PUBLISHED';
    };

    $scope.getEnableTooltip = function (env) {
        if ($scope.canEnableEnvironment(env)) {
            return 'Toggle environment on/off';
        }

        return 'Environment can only be enabled with a PUBLISHED template';
    };

    $scope.getTemplateValidationMessage = function (env) {
        if (!env.selectedTemplateId) {
            return '';
        }

        var template = $scope.availableTemplates.find(function (t) {
            return t.id === env.selectedTemplateId;
        });

        if (!template) {
            return 'Template not found';
        }

        if (template.templateStatus !== 'PUBLISHED') {
            return 'Only PUBLISHED templates can be assigned to an environment';
        }

        return '';
    };

    // ============================================
    // TEMPLATE FILTERING
    // ============================================

    $scope.getAvailableTemplatesForEnv = function (env) {
        // Only PUBLISHED templates may be assigned to any environment.
        return $scope.availableTemplates.filter(function (template) {
            return template.templateStatus === 'PUBLISHED';
        });
    };

    // ============================================
    // EVENT HANDLERS
    // ============================================

    $scope.onEnvTypeChanged = function (env) {
        console.log('🔄 Environment type changed:', env.envType);

        $scope.markWorkflowChanged();

        if (!$scope.isTemplateValidForEnv(env)) {
            env.selectedTemplateId = null;
            env.templateInstanceId = null;
            env.templateInstanceStatus = null;
            env.templateInstanceVersion = null;
        }

        // isTemplateValidForEnv now enforces PUBLISHED-only for all env types;
        // the block above already clears the selection when the rule is violated.
    };

    $scope.onTemplateSelected = function () {
        console.log('📄 Template selected:', $scope.env.selectedTemplateId);

        if (!$scope.env.selectedTemplateId) {
            $scope.env.templateInstanceId = null;
            $scope.env.templateInstanceStatus = null;
            $scope.env.templateInstanceVersion = null;
            $scope.validationMessage = '';
            return;
        }

        var template = $scope.availableTemplates.find(function (t) {
            return t.id === $scope.env.selectedTemplateId;
        });

        if (template) {
            // ✅ Guardar estado anterior
            var previousStatus = $scope.env.templateInstanceStatus;
            var wasDisabled = !$scope.env.isEnabled;

            $scope.env.templateInstanceId = template.id;
            $scope.env.templateInstanceStatus = template.templateStatus;
            $scope.env.templateInstanceVersion = template.templateVersion;

            console.log('  → Template details:', {
                status: template.templateStatus,
                version: template.templateVersion,
                name: template.templateName
            });

            // ✅ Lógica de auto-enable/disable
            if (template.templateStatus !== 'PUBLISHED' && $scope.env.isEnabled) {
                // Deshabilitar si NO es PUBLISHED y estaba habilitado
                console.log('  → Auto-disabling environment (non-PUBLISHED template)');
                $scope.env.isEnabled = false;
            } else if (template.templateStatus === 'PUBLISHED' && wasDisabled && previousStatus !== 'PUBLISHED' && !isNew) {
                // ✅ HABILITAR si pasa de DRAFT/otro a PUBLISHED, estaba disabled, y NO es nuevo
                // (los nuevos siempre arrancan disabled)
                console.log('  → Auto-enabling environment (upgraded to PUBLISHED)');
                $scope.env.isEnabled = true;
            }
        }

        $scope.updateValidationMessage();
    };

    $scope.onEnvEnabledToggled = function (env) {
        updateWorkflowChangesFlag();
    };

    // ============================================
    // GUARDAR CAMBIOS
    // ============================================

    $scope.saveWorkflowChanges = function () {
        if ($scope.assignmentChecksPending) return;
        console.log('💾 Saving workflow changes');

        if (!$scope.isWorkflowValid()) {
            dialogService.showErrorDialog(
                'Validation Error',
                'Please fix all validation errors before saving.'
            );
            return;
        }

        // ✅ VALIDAR versiones antes de guardar
        var sequenceValidation = validateSequenceRules($scope.sortedEnvironments);

        if (!sequenceValidation.valid) {
            dialogService.showErrorDialog(
                'Invalid Template Version Sequence',
                sequenceValidation.message
            );
            return;
        }

        $scope.updateAllSequences();

        var updatedEnvironments = $scope.sortedEnvironments.map(function (env) {
            return {
                id: env.id,
                name: env.name,
                description: env.description,
                envType: env.envType,
                envTypeId: env.envTypeId,
                isEnabled: env.isEnabled,
                envSequence: env.envSequence,
                templateInstanceId: env.templateInstanceId || null,
                templateInstanceStatus: env.templateInstanceStatus || null,
                templateInstanceVersion: env.templateInstanceVersion || null
            };
        });

        dialogService.showDecisionDialog(
            'Save Workflow Changes',
            'Are you sure you want to save all changes to the environment workflow?<br><br>' +
            'This will update sequence, configuration, and template assignments for all environments.'
        ).then(function (decision) {
            if (decision === 'proceed') {
                // Recheck every changed assignment against persisted resources at save time.
                // This also covers promotion/shift operations and agents going offline after a bump.
                return $q.all(updatedEnvironments.filter(function (env) {
                    var original = $scope.originalEnvironments.find(function (item) { return item.id === env.id; });
                    return env.id && env.templateInstanceId &&
                        (!original || original.templateInstanceId !== env.templateInstanceId);
                }).map(function (env) {
                    return validateTemplateAssignment(env, env.templateInstanceId);
                })).then(function (results) {
                    if (results.every(function (allowed) { return allowed; })) {
                        performBatchUpdate(updatedEnvironments);
                    }
                });
            }
        });
    };

    function performBatchUpdate(updatedEnvironments) {

        // ⚠️  BUG FIX: $mdDialog.show() is asynchronous — it returns a promise
        // that resolves only after the dialog is fully mounted and animated in.
        // If the HTTP call is very fast (e.g. a trivial change), .then() can fire
        // before the loading dialog exists in the stack, so hideLoadingDialog()
        // calls $mdDialog.hide() on an empty stack and the dialog appears orphaned.
        //
        // Fix: chain the HTTP call off the showLoadingDialog promise so it only
        // starts after the dialog is confirmed open. hideLoadingDialog() will
        // always find it in the stack.
        dialogService.showLoadingDialog(
            'Applying Changes',
            'Updating environments and propagating changes across the workflow...'
        ).then(function () {

        // Loading dialog is now fully open — safe to start the HTTP call.
        ProfileService.batchUpdateEnvironments($scope.profile.id, updatedEnvironments)
            .then(function (response) {
                console.log('✅ Workflow updated successfully');

                dialogService.hideLoadingDialog();

                // ============================================================
                // Sincronizar IDs del backend → sortedEnvironments
                // Los nuevos envs no tenían ID; el backend los asignó y los
                // devuelve en el profile actualizado.
                // ============================================================
                var savedProfile = response.data;

                if (savedProfile && savedProfile.environments && savedProfile.environments.length) {

                    // Ordenar la respuesta del backend por sequence para tener
                    // el mismo orden que nuestra lista local
                    var backendEnvs = savedProfile.environments.slice().sort(function (a, b) {
                        return (a.envSequence || 0) - (b.envSequence || 0);
                    });

                    $scope.sortedEnvironments.forEach(function (localEnv) {
                        if (localEnv.id) {
                            // Ya tenía ID → buscar por ID para actualizar campos del servidor
                            var match = backendEnvs.find(function (be) {
                                return be.id === localEnv.id;
                            });
                            if (match) {
                                localEnv.id = match.id;
                                localEnv.envSequence = match.envSequence;
                                localEnv.templateInstanceId = match.templateInstanceId || localEnv.templateInstanceId;
                                localEnv.templateInstanceStatus = match.templateInstanceStatus || localEnv.templateInstanceStatus;
                                localEnv.templateInstanceVersion = match.templateInstanceVersion || localEnv.templateInstanceVersion;
                            }
                        } else {
                            // Env nuevo (sin ID) → buscar por nombre + envType como clave natural
                            var match = backendEnvs.find(function (be) {
                                return !be._matched &&
                                    be.name === localEnv.name &&
                                    be.envType === localEnv.envType;
                            });
                            if (match) {
                                match._matched = true; // evitar que dos locales usen el mismo backend env
                                localEnv.id = match.id;
                                localEnv.envSequence = match.envSequence;
                                localEnv.templateInstanceId = match.templateInstanceId || localEnv.templateInstanceId;
                                localEnv.templateInstanceStatus = match.templateInstanceStatus || localEnv.templateInstanceStatus;
                                localEnv.templateInstanceVersion = match.templateInstanceVersion || localEnv.templateInstanceVersion;
                                console.log('🆕 ID asignado a nuevo env "' + localEnv.name + '":', localEnv.id);
                            } else {
                                console.warn('⚠️ No se encontró match en backend para nuevo env:', localEnv.name);
                            }
                        }
                    });

                    // Actualizar también el profile raíz con los datos del servidor
                    $scope.profile.environments = angular.copy($scope.sortedEnvironments);

                    // Limpiar flags temporales del backend
                    backendEnvs.forEach(function (be) { delete be._matched; });

                } else {
                    // Fallback: si el backend no devuelve el profile, al menos
                    // sincronizar el profile local con lo que tenemos
                    $scope.profile.environments = angular.copy($scope.sortedEnvironments);
                }

                // ============================================================

                $mdToast.show(
                    $mdToast.simple()
                        .textContent('✅ Environment workflow updated successfully')
                        .position('top right')
                        .hideDelay(3000)
                );

                $scope.workflowEditMode = false;
                $scope.workflowHasChanges = false;
            })
            .catch(function (error) {
                console.error('❌ Error updating workflow:', error);

                // Close loading dialog before showing the error
                dialogService.hideLoadingDialog();

                var errorMsg = 'Failed to update workflow.';
                if (error.data && error.data.message) {
                    errorMsg += ' ' + error.data.message;
                }

                dialogService.showErrorDialog('Update Failed', errorMsg);
            });

        }); // end showLoadingDialog.then — HTTP only runs once dialog is open
    }

    // ============================================
    // ENVIRONMENT ACTIONS
    // ============================================

    $scope.toggleEnvironment = function (env) {
        console.log('🔄 Toggling environment:', env.name, '→', env.isEnabled);
        $scope.markWorkflowChanged();
    };

    $scope.quickEditEnvironment = function (env) {
        console.log('✏️ Quick edit environment:', env.name);
    };

    $scope.deleteEnvironment = function (env) {
        if (env.agent_status === 'ONLINE' || env.agent_status === 'STALLED') {
            $mdToast.show(
                $mdToast.simple()
                    .textContent('Cannot delete: Agent must be OFFLINE')
                    .position('top right')
                    .hideDelay(3000)
            );
            return;
        }

        if (!env.deleteConfirm) {
            env.deleteConfirm = true;

            $timeout(function () {
                env.deleteConfirm = false;
            }, 3000);
        } else {
            var index = $scope.sortedEnvironments.indexOf(env);
            if (index !== -1) {
                $scope.sortedEnvironments.splice(index, 1);
                $scope.updateAllSequences();
                updateWorkflowChangesFlag();

                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Environment marked for deletion')
                        .position('top right')
                        .hideDelay(2000)
                );
            }

            env.deleteConfirm = false;
        }
    };

    $scope.openEditEnvironmentDialog = function (env) {
        console.log('✏️ Opening edit dialog for:', env.name);

        // ✅ Guardar el envType original para detectar cambios
        var originalEnvType = env.envType;
        var originalEnvTypeId = getEnvTypeIdSafe(env);

        $mdDialog.show({
            controller: 'EnvironmentDialogController',
            templateUrl: 'profile/tabs/environments/edit-environment-dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            multiple: true,
            locals: {
                environment: angular.copy(env),
                availableTemplates: $scope.availableTemplates,
                envTypes: $scope.envTypes,
                currentEnvs: $scope.sortedEnvironments,
                isNew: false,
                profileId: $scope.profile && $scope.profile.id
            }
        })
            .then(function (updatedEnv) {
                var index = $scope.sortedEnvironments.findIndex(function (e) {
                    return e.id === updatedEnv.id;
                });

                if (index === -1) {
                    console.error('❌ Environment not found in array');
                    return;
                }

                // Preservar propiedades del sistema
                updatedEnv.agent_status = env.agent_status;
                updatedEnv.agent_id = env.agent_id;

                var newEnvTypeId = getEnvTypeIdSafe(updatedEnv);
                var envTypeChanged = originalEnvTypeId !== newEnvTypeId;

                console.log('🔍 Edit result:', {
                    envTypeChanged: envTypeChanged,
                    originalEnvTypeId: originalEnvTypeId,
                    newEnvTypeId: newEnvTypeId,
                    originalType: originalEnvType,
                    newType: updatedEnv.envType
                });

                // ✅ CASO 1: El tipo de environment NO cambió - simple update
                if (!envTypeChanged) {
                    console.log('📝 Environment type unchanged - simple update');

                    // Validar que el cambio no rompa reglas de versión
                    var tempArray = angular.copy($scope.sortedEnvironments);
                    tempArray[index] = updatedEnv;

                    var validation = validateSequenceRules(tempArray);

                    if (!validation.valid) {
                        dialogService.showErrorDialog(
                            'Invalid Template Version',
                            'Cannot apply these changes:\n\n' + validation.message
                        );
                        return;
                    }

                    // Aplicar cambios en la misma posición
                    updatedEnv.envSequence = env.envSequence;
                    $scope.sortedEnvironments[index] = updatedEnv;
                    $scope.markWorkflowChanged();
                    return;
                }

                // ✅ CASO 2: El tipo de environment CAMBIÓ - reposicionar
                console.log('🔄 Environment type changed - repositioning required');

                // Remover el environment de su posición actual
                $scope.sortedEnvironments.splice(index, 1);

                // Encontrar la nueva posición correcta basada en envTypeId
                var insertIndex = findCorrectPositionForEnvType(newEnvTypeId, $scope.sortedEnvironments);

                console.log('📍 New position:', insertIndex, '(envTypeId:', newEnvTypeId + ')');

                // Crear array temporal con el environment en la nueva posición
                var tempArray = angular.copy($scope.sortedEnvironments);
                tempArray.splice(insertIndex, 0, updatedEnv);

                // ✅ Validar que la nueva configuración sea válida
                var validation = validateWorkflowRules(tempArray);

                if (!validation.valid) {
                    // Revertir: volver a insertar en posición original
                    $scope.sortedEnvironments.splice(index, 0, env);

                    dialogService.showErrorDialog(
                        'Invalid Environment Configuration',
                        'Cannot move this environment to the new position:\n\n' +
                        validation.message +
                        '\n\nThe environment type was changed, but the template version ' +
                        'would break the workflow sequence. Please adjust the template version first.'
                    );
                    return;
                }

                // ✅ Validación pasó - aplicar el reposicionamiento
                $scope.sortedEnvironments.splice(insertIndex, 0, updatedEnv);

                // Actualizar todas las secuencias
                $scope.updateAllSequences();
                $scope.markWorkflowChanged();

                // Notificar al usuario del reposicionamiento
                var positionMessage = insertIndex < index
                    ? 'moved up in the workflow'
                    : insertIndex > index
                        ? 'moved down in the workflow'
                        : 'remains in the same position';

                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Environment type changed. "' + updatedEnv.name +
                            '" was ' + positionMessage + ' to maintain sequence order.')
                        .position('top right')
                        .hideDelay(4000)
                );

                console.log('✅ Environment repositioned successfully');
            })
            .catch(function () {
                console.log('Edit dialog cancelled');
            });
    };

    // ✅ NUEVA FUNCIÓN: Encontrar la posición correcta para un envTypeId
    function findCorrectPositionForEnvType(envTypeId, environmentsArray) {
        // Si el array está vacío, insertar al inicio
        if (!environmentsArray || environmentsArray.length === 0) {
            return 0;
        }

        // Buscar la primera posición donde el envTypeId sea mayor
        for (var i = 0; i < environmentsArray.length; i++) {
            var existingEnvTypeId = getEnvTypeIdSafe(environmentsArray[i]);

            if (existingEnvTypeId > envTypeId) {
                // Insertar ANTES de este environment
                return i;
            }
        }

        // Si no encontramos ninguno mayor, insertar al final
        return environmentsArray.length;
    }

    $scope.openAddEnvironmentDialog = function () {
        console.log('➕ Opening add dialog');

        $mdDialog.show({
            controller: 'EnvironmentDialogController',
            templateUrl: 'profile/tabs/environments/edit-environment-dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            multiple: true,
            locals: {
                environment: null,
                availableTemplates: $scope.availableTemplates,
                envTypes: $scope.envTypes,
                currentEnvs: $scope.sortedEnvironments,
                isNew: true,
                profileId: $scope.profile && $scope.profile.id
            }
        })
            .then(function (newEnv) {
                if (!$scope.sortedEnvironments) $scope.sortedEnvironments = [];

                newEnv.id = null;
                newEnv.isEnabled = false;
                newEnv.agent_status = 'OFFLINE';
                newEnv.agent_id = null;

                // ✅ ENCONTRAR la posición correcta basada en envTypeId (orden ascendente)
                var newEnvTypeId = getEnvTypeIdSafe(newEnv);
                var insertIndex = $scope.sortedEnvironments.length; // default: al final

                for (var i = 0; i < $scope.sortedEnvironments.length; i++) {
                    var existingEnvTypeId = getEnvTypeIdSafe($scope.sortedEnvironments[i]);

                    // Insertar ANTES del primer environment con envTypeId mayor
                    if (existingEnvTypeId > newEnvTypeId) {
                        insertIndex = i;
                        break;
                    }
                }

                // ✅ VALIDAR que el nuevo environment cumpla las reglas de secuencia
                var tempArray = angular.copy($scope.sortedEnvironments);
                tempArray.splice(insertIndex, 0, newEnv); // Insertar en la posición correcta

                var validation = validateWorkflowRules(tempArray);

                if (!validation.valid) {
                    dialogService.showErrorDialog(
                        'Invalid Environment Configuration',
                        'Cannot add this environment:\n\n' +
                        validation.message +
                        '\n\nPlease adjust the environment type or template version.'
                    );
                    return;
                }

                // ✅ Validación pasó - insertar el environment en la posición correcta
                $scope.sortedEnvironments.splice(insertIndex, 0, newEnv);

                // ✅ Actualizar secuencias después de la inserción
                $scope.updateAllSequences();
                updateWorkflowChangesFlag();

                console.log('➕ New environment added at position:', insertIndex, 'with envTypeId:', newEnvTypeId);
            })
            .catch(function () {
                console.log('Add dialog cancelled');
            });
    };

    // ============================================
    // DRAG & DROP - EVENT DELEGATION
    // ============================================

    var dragContainer = null;

    // Publicar estado de edición en $rootScope para que ProfileDetailsDialogController pueda consultarlo
    $scope.$watch('workflowEditMode', function (editMode) {
        $rootScope._envWorkflowEditMode    = !!editMode;
        $rootScope._envWorkflowCancelFn    = editMode ? $scope.cancelWorkflowEdit : null;
        if (editMode) {
            // Esperar a que Angular termine COMPLETAMENTE de renderizar
            $timeout(function () {
                // Segundo timeout para asegurar
                $timeout(function () {
                    setupDragAndDropWithDelegation();
                }, 200);
            }, 100);
        } else {
            cleanupDragAndDrop();
        }
    });

    $scope.$watch('workflowHasChanges', function (hasChanges) {
        $rootScope._envWorkflowHasChanges = !!hasChanges;
    });

    // También setup cuando cambie el array
    $scope.$watchCollection('sortedEnvironments', function (newVal) {
        if (newVal && $scope.workflowEditMode) {
            $timeout(function () {
                setupDragAndDropWithDelegation();
            }, 100);
        }
    });

    function setupDragAndDropWithDelegation() {
        console.log('🎨 Setting up drag & drop with event delegation');

        // Primero limpiar
        cleanupDragAndDrop();

        dragContainer = document.querySelector('.workflow-track');

        if (!dragContainer) {
            console.error('❌ Workflow track not found!');
            return;
        }

        // FORZAR draggable en TODAS las cards - CON RETRY
        var attempts = 0;
        var maxAttempts = 5;

        function forceSetupCards() {
            var cards = dragContainer.querySelectorAll('.workflow-env-card');
            console.log('📦 Attempt', attempts + 1, '- Found', cards.length, 'cards');

            if (cards.length === 0 && attempts < maxAttempts) {
                attempts++;
                $timeout(forceSetupCards, 100);
                return;
            }

            if (cards.length === 0) {
                console.error('❌ No cards found after', maxAttempts, 'attempts');
                return;
            }

            // Forzar atributos en TODAS
            cards.forEach(function (card, i) {
                card.setAttribute('draggable', 'true');
                card.setAttribute('data-card-index', i.toString());

                console.log('   ✓ Card', i, ':', {
                    id: card.id,
                    draggable: card.getAttribute('draggable'),
                    dataIndex: card.getAttribute('data-card-index'),
                    name: card.querySelector('.env-name-compact') ?
                        card.querySelector('.env-name-compact').textContent : 'unknown'
                });
            });

            // Event listeners en el CONTENEDOR (event delegation)
            dragContainer.addEventListener('dragstart', handleDragStart, false);
            dragContainer.addEventListener('dragover', handleDragOver, false);
            dragContainer.addEventListener('dragenter', handleDragEnter, false);
            dragContainer.addEventListener('drop', handleDrop, false);
            dragContainer.addEventListener('dragend', handleDragEnd, false);

            console.log('✅ Event delegation setup complete for', cards.length, 'cards');
        }

        forceSetupCards();
    }

    function cleanupDragAndDrop() {
        if (dragContainer) {
            dragContainer.removeEventListener('dragstart', handleDragStart, false);
            dragContainer.removeEventListener('dragover', handleDragOver, false);
            dragContainer.removeEventListener('dragenter', handleDragEnter, false);
            dragContainer.removeEventListener('drop', handleDrop, false);
            dragContainer.removeEventListener('dragend', handleDragEnd, false);
        }
    }

    function handleDragStart(e) {
        var card = e.target.closest('.workflow-env-card');
        if (!card) return;

        if (!$scope.workflowEditMode) {
            e.preventDefault();
            return;
        }

        var index = parseInt(card.getAttribute('data-card-index'));
        console.log('🎯 DRAG START - card:', index, '- name:', $scope.sortedEnvironments[index].name);

        $scope.$apply(function () {
            $scope.draggedIndex = index;
            $scope.sortedEnvironments[index].isDragging = true;
        });

        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', index.toString());

        card.classList.add('dragging');
    }

    function handleDragOver(e) {
        var card = e.target.closest('.workflow-env-card');
        if (!card || $scope.draggedIndex === null) return;

        e.preventDefault();
        e.stopPropagation();
        e.dataTransfer.dropEffect = 'move';

        return false;
    }

    function handleDragEnter(e) {
        var card = e.target.closest('.workflow-env-card');
        if (!card || $scope.draggedIndex === null) return;

        e.preventDefault();
    }

    function handleDrop(e) {
        var card = e.target.closest('.workflow-env-card');
        if (!card || $scope.draggedIndex === null) return;

        e.preventDefault();
        e.stopPropagation();

        var dropIndex = parseInt(card.getAttribute('data-card-index'));
        console.log('📍 DROP - from:', $scope.draggedIndex, 'to:', dropIndex);

        if ($scope.draggedIndex !== dropIndex) {
            var draggedEnv = $scope.sortedEnvironments[$scope.draggedIndex];
            var targetEnv = $scope.sortedEnvironments[dropIndex];

            // ✅ VALIDAR VERSIONES antes de permitir el drop
            var validation = canDropAt(
                draggedEnv,
                targetEnv,
                $scope.sortedEnvironments,
                $scope.draggedIndex,
                dropIndex
            );

            if (!validation.valid) {
                console.warn('❌ Drop rejected:', validation.message);

                // ✅ Usar el nuevo banner de error en lugar del toast
                $scope.$apply(function () {
                    $scope.showWorkflowError(validation.message, 'error');
                });

                // No permitir el drop
                return false;
            }

            // ✅ Validación pasó - permitir el drop
            $scope.$apply(function () {
                console.log('   Moving:', draggedEnv.name, '→', targetEnv.name);
                console.log('   Before:', $scope.sortedEnvironments.map(function (e) { return e.name; }).join(', '));

                // Remover
                $scope.sortedEnvironments.splice($scope.draggedIndex, 1);

                // Ajustar índice
                var newIndex = dropIndex;
                if ($scope.draggedIndex < dropIndex) {
                    newIndex--;
                }

                // Insertar
                $scope.sortedEnvironments.splice(newIndex, 0, draggedEnv);

                console.log('   After:', $scope.sortedEnvironments.map(function (e) { return e.name; }).join(', '));

                // Actualizar secuencias
                $scope.updateAllSequences();
                updateWorkflowChangesFlag();

                // ✅ Limpiar error si había uno
                $scope.hideWorkflowError();
            });

            // Re-setup para actualizar índices
            $timeout(function () {
                var cards = document.querySelectorAll('.workflow-env-card');
                cards.forEach(function (c, i) {
                    c.setAttribute('data-card-index', i);
                });
            }, 50);
        }

        return false;
    }

    function handleDragEnd(e) {
        var card = e.target.closest('.workflow-env-card');
        if (!card) return;

        console.log('🏁 DRAG END');

        // Limpiar todas las cards
        var allCards = document.querySelectorAll('.workflow-env-card');
        allCards.forEach(function (c) {
            c.classList.remove('dragging');
        });

        $scope.$apply(function () {
            $scope.sortedEnvironments.forEach(function (env) {
                env.isDragging = false;
            });
            $scope.draggedIndex = null;
        });
    }

    // ============================================
    // AUTO-INICIALIZACIÓN
    // ============================================

    $scope.$watch('profile.environments', function (newVal) {
        if (newVal) {
            $scope.sortEnvironmentsBySequence();
        }
    }, true);

    $scope.computeWorkflowMiniDiagram = function () {
        if (!$scope.sortedEnvironments) return;

        $scope.workflowMiniNodes = $scope.sortedEnvironments.map(function (env) {
            return {
                name: env.name,
                envType: env.envType,
                isEnabled: env.isEnabled,
                status: env.templateInstanceStatus,
                version: env.templateInstanceVersion
            };
        });
    };

    // Recomputar cuando cambie el array
    $scope.$watch('sortedEnvironments', function () {
        $scope.computeWorkflowMiniDiagram();
    }, true);

    $scope.loadInitialData();

    // ============================================
    // VALIDACIÓN DE VERSIONES DE TEMPLATE
    // ============================================

    function compareVersions(v1, v2) {
        if (!v1 || !v2) return 0;

        var p1 = v1.toString().split('.');
        var p2 = v2.toString().split('.');

        var M1 = parseInt(p1[0], 10) || 0;
        var N1 = parseInt(p1[1], 10) || 0;

        var M2 = parseInt(p2[0], 10) || 0;
        var N2 = parseInt(p2[1], 10) || 0;

        if (M1 !== M2) return M1 - M2;
        return N1 - N2;
    }

    function validateSequenceRules(environments) {
        var errors = [];

        for (var i = 0; i < environments.length - 1; i++) {
            var current = environments[i];
            var next = environments[i + 1];

            // Solo validar si AMBOS tienen template asignado
            if (current.templateInstanceVersion && next.templateInstanceVersion) {
                var comparison = compareVersions(
                    current.templateInstanceVersion,
                    next.templateInstanceVersion
                );

                // Current debe ser >= next (versiones descendentes)
                if (comparison < 0) {
                    errors.push(
                        'Environment "' + current.name +
                        '" (v' + current.templateInstanceVersion + ') cannot come before "' + next.name +
                        '" (v' + next.templateInstanceVersion + '). ' +
                        'Template versions must be in descending order (higher versions first).'
                    );
                }
            }
        }

        return {
            valid: errors.length === 0,
            message: errors.join('\n\n')
        };
    }

    function canDropAt(draggedEnv, targetEnv, allEnvironments, draggedIndex, dropIndex) {
        // Crear copia temporal del array con el nuevo orden
        var tempArray = angular.copy(allEnvironments);

        // Simular el movimiento
        tempArray.splice(draggedIndex, 1);

        var newIndex = dropIndex;
        if (draggedIndex < dropIndex) {
            newIndex--;
        }

        tempArray.splice(newIndex, 0, draggedEnv);

        // Validar el nuevo orden
        return validateWorkflowRules(tempArray);
    }

    function getEnvTypeIdSafe(env) {
        if (!env) return null;

        if (env.envTypeId != null) return parseInt(env.envTypeId, 10);
        if (env.environmentTypeId != null) return parseInt(env.environmentTypeId, 10);
        if (env.environmentType_id != null) return parseInt(env.environmentType_id, 10);

        return null;
    }

    function validateEnvTypeOrder(environments) {
        var errors = [];

        for (var i = 0; i < environments.length - 1; i++) {
            var a1 = environments[i];
            var a2 = environments[i + 1];

            var id1 = getEnvTypeIdSafe(a1);
            var id2 = getEnvTypeIdSafe(a2);

            if (id1 == null || id2 == null) {
                errors.push('Missing envTypeId in "' + (a1 && a1.name ? a1.name : ('#' + i)) +
                    '" or "' + (a2 && a2.name ? a2.name : ('#' + (i + 1))) + '".');
                continue;
            }

            // ✅ Regla: estrictamente creciente
            if (!(id1 < id2)) {
                errors.push(
                    '"' + a1.name + '" (envTypeId=' + id1 + ') cannot come before "' +
                    a2.name + '" (envTypeId=' + id2 + '). Environment types must be in ascending order.'
                );
            }
        }

        return { valid: errors.length === 0, message: errors.join('\n\n') };
    }

    function validateWorkflowRules(environments) {
        var typeCheck = validateEnvTypeOrder(environments);
        if (!typeCheck.valid) return typeCheck;

        return validateSequenceRules(environments);
    }

    // ============================================
    // PROMOTION (UI ONLY)
    // ============================================

    $scope.getNextEnv = function (index) {
        if (!$scope.sortedEnvironments || index == null) return null;
        return $scope.sortedEnvironments[index + 1] || null;
    };

    $scope.canPromoteToNext = function (env, index) {
        var next = $scope.getNextEnv(index);
        if (!next) return false;

        if (!env || env.templateInstanceStatus !== 'PUBLISHED') return false;

        if (!env.templateInstanceVersion) return false;

        if (!next.templateInstanceVersion) return true;

        return compareVersions(env.templateInstanceVersion, next.templateInstanceVersion) > 0;
    };

    $scope.getPromoteTooltip = function (env, index) {
        var next = $scope.getNextEnv(index);
        if (!next) return 'No next environment to promote';

        if (!env || !env.templateInstanceId) {
            return 'Nothing to promote (no template assigned)';
        }

        if (env.templateInstanceStatus !== 'PUBLISHED') {
            return 'Only PUBLISHED templates can be promoted';
        }

        if (!env.templateInstanceVersion) {
            return 'Nothing to promote (no template version)';
        }

        if (!next.templateInstanceVersion) {
            return 'Promote v' + env.templateInstanceVersion + ' to ' + next.name;
        }

        var cmp = compareVersions(env.templateInstanceVersion, next.templateInstanceVersion);

        if (cmp > 0) {
            return 'Promote v' + env.templateInstanceVersion + ' to ' + next.name + ' (currently v' + next.templateInstanceVersion + ')';
        }

        if (cmp === 0) {
            return next.name + ' already has v' + next.templateInstanceVersion;
        }

        return 'Cannot promote: target has higher version (v' + next.templateInstanceVersion + ')';
    };

    $scope.promoteToNext = function (env, index) {
        if (!$scope.workflowEditMode || $scope.assignmentChecksPending) return;
        if (!env || env.templateInstanceStatus !== 'PUBLISHED') {
            $mdToast.show(
                $mdToast.simple()
                    .textContent('❌ Only PUBLISHED templates can be promoted.')
                    .position('top right')
                    .hideDelay(3000)
            );
            return;
        }

        var next = $scope.getNextEnv(index);
        if (!next) return;

        if (!$scope.canPromoteToNext(env, index)) {
            $mdToast.show(
                $mdToast.simple()
                    .textContent('No promotion needed (target already same/higher version).')
                    .position('top right')
                    .hideDelay(2500)
            );
            return;
        }

        var templateId = env.templateInstanceId;
        if (!templateId) return;
        return applyValidatedVersionChange(next, index + 1, { id: templateId }, function () {
            return $scope.sortedEnvironments[index] === env && env.templateInstanceId === templateId &&
                $scope.canPromoteToNext(env, index);
        }, function () {
            next.selectedTemplateId = env.templateInstanceId || env.selectedTemplateId || null;
            next.templateInstanceId = env.templateInstanceId || null;
            next.templateInstanceStatus = env.templateInstanceStatus || null;
            next.templateInstanceVersion = env.templateInstanceVersion || null;

            // ✅ Como solo promovemos PUBLISHED, no necesitamos deshabilitar
            // Pero por consistencia, validamos
            if (env.templateInstanceStatus !== 'PUBLISHED' && next.isEnabled) {
                next.isEnabled = false;
                console.log('⚠️ Auto-disabled', next.name, '(non-PUBLISHED template)');
            }

            updateWorkflowChangesFlag();
            triggerVersionAnim(next, 'promote');

            $mdToast.show(
                $mdToast.simple()
                    .textContent('✅ Promoted v' + env.templateInstanceVersion + ' to ' + next.name)
                    .position('top right')
                    .hideDelay(2500)
            );
        });
    };

    // ============================================
    // BUMP VERSION (UI ONLY)
    // ============================================

    $scope.getPrevEnv = function (index) {
        if (!$scope.sortedEnvironments || index == null) return null;
        if (index <= 0) return null;
        return $scope.sortedEnvironments[index - 1] || null;
    };

    function normEnvType(t) {
        return (t || '').toString().toUpperCase();
    }

    function isProtectedEnvType(envType) {
        var t = normEnvType(envType);
        return t === 'PRODUCTION' || t === 'PROD-MIRROR';
    }

    function isTemplateAllowedInEnv(env, tpl) {
        // Only PUBLISHED templates may be assigned to any environment type.
        return tpl.templateStatus === 'PUBLISHED';
    }

    function getTemplatesAllowedForBump(env) {
        return ($scope.availableTemplates || [])
            .filter(function (t) {
                return !!t && !!t.templateVersion && isTemplateAllowedInEnv(env, t);
            })
            .sort(function (a, b) {
                return compareVersions(b.templateVersion, a.templateVersion);
            });
    }

    function getImmediateHigherTemplate(allDesc, currentVersion) {
        if (!allDesc || !allDesc.length || !currentVersion) return null;

        var best = null;

        for (var i = 0; i < allDesc.length; i++) {
            var v = allDesc[i].templateVersion;
            if (compareVersions(v, currentVersion) > 0) {
                if (!best || compareVersions(v, best.templateVersion) < 0) {
                    best = allDesc[i];
                }
            }
        }

        return best;
    }

    function getImmediateLowerTemplate(allDesc, currentVersion) {
        if (!allDesc || !allDesc.length || !currentVersion) return null;

        var best = null;

        for (var i = 0; i < allDesc.length; i++) {
            var v = allDesc[i].templateVersion;
            if (compareVersions(v, currentVersion) < 0) {
                if (!best || compareVersions(v, best.templateVersion) > 0) {
                    best = allDesc[i];
                }
            }
        }

        return best;
    }

    $scope.canBumpVersion = function (env, index) {
        if (!$scope.workflowEditMode) return false;
        if (!env || !env.templateInstanceVersion) return false;

        var allowed = getTemplatesAllowedForBump(env);
        var higherTpl = getImmediateHigherTemplate(allowed, env.templateInstanceVersion);
        if (!higherTpl) return false;

        var prev = $scope.getPrevEnv(index);
        if (prev && prev.templateInstanceVersion) {
            if (compareVersions(prev.templateInstanceVersion, higherTpl.templateVersion) < 0) return false;
        }

        var next = $scope.getNextEnv(index);
        if (next && next.templateInstanceVersion) {
            if (compareVersions(higherTpl.templateVersion, next.templateInstanceVersion) < 0) return false;
        }

        return true;
    };

    $scope.getBumpTooltip = function (env, index) {
        if (!$scope.workflowEditMode) return 'Edit mode required';
        if (!env || !env.templateInstanceVersion) return 'No template version';

        var allowed = getTemplatesAllowedForBump(env);
        var higherTpl = getImmediateHigherTemplate(allowed, env.templateInstanceVersion);
        if (!higherTpl) return 'No higher existing version available';

        return 'Bump to existing v' + higherTpl.templateVersion + ' (' + higherTpl.templateStatus + ')';
    };

    // Ask the orchestrator: offline agents only block resource changes that need a pull.
    function validateTemplateAssignment(env, templateId) {
        if (!env.id || !templateId) return $q.when(true);
        if (!$scope.profile || !$scope.profile.id) return $q.when(false);

        $scope.assignmentChecksPending++;
        return ProfileService.checkTemplateAssignment($scope.profile.id, env.id, templateId)
            .then(function (response) {
                var result = response.data || {};
                if (result.allowed === true) return true;
                $scope.showWorkflowError(result.reason || 'This template cannot be applied right now.');
                return false;
            }, function (error) {
                $scope.showWorkflowError((error && error.data && error.data.reason) ||
                    'Could not verify whether this template can be applied. Please retry.');
                return false;
            })
            .finally(function () {
                $scope.assignmentChecksPending--;
            });
    }

    function applyValidatedVersionChange(env, index, template, canChange, applyChange) {
        if ($scope.assignmentChecksPending) return;
        var previousTemplateId = env.templateInstanceId;
        return validateTemplateAssignment(env, template.id).then(function (allowed) {
            // Ignore responses for an environment removed, cancelled, or changed during the request.
            if (!allowed || !$scope.workflowEditMode || $scope.sortedEnvironments[index] !== env ||
                env.templateInstanceId !== previousTemplateId || !canChange(env, index)) return;
            applyChange();
        });
    }

    $scope.bumpTemplateVersion = function (env, index) {
        if (!$scope.canBumpVersion(env, index)) return;

        var allowed = getTemplatesAllowedForBump(env);
        var higherTpl = getImmediateHigherTemplate(allowed, env.templateInstanceVersion);
        if (!higherTpl) return;

        return applyValidatedVersionChange(env, index, higherTpl, $scope.canBumpVersion, function () {
            // ✅ Guardar estado anterior
            var previousStatus = env.templateInstanceStatus;
            var wasDisabled = !env.isEnabled;

            env.selectedTemplateId = higherTpl.id;
            env.templateInstanceId = higherTpl.id;
            env.templateInstanceStatus = higherTpl.templateStatus;
            env.templateInstanceVersion = higherTpl.templateVersion;

            // ✅ Lógica de auto-enable/disable
            if (higherTpl.templateStatus !== 'PUBLISHED' && env.isEnabled) {
                // Deshabilitar si NO es PUBLISHED y estaba habilitado
                env.isEnabled = false;
                console.log('⚠️ Auto-disabled', env.name, '(non-PUBLISHED template:', higherTpl.templateStatus + ')');
            } else if (higherTpl.templateStatus === 'PUBLISHED' && wasDisabled && previousStatus !== 'PUBLISHED') {
                // ✅ HABILITAR si pasa de DRAFT/otro a PUBLISHED y estaba disabled
                env.isEnabled = true;
                console.log('✅ Auto-enabled', env.name, '(upgraded to PUBLISHED)');

                $mdToast.show(
                    $mdToast.simple()
                        .textContent('✅ Environment auto-enabled (now using PUBLISHED template)')
                        .position('top right')
                        .hideDelay(3000)
                );
            }

            updateWorkflowChangesFlag();
            triggerVersionAnim(env, 'up');

            $mdToast.show(
                $mdToast.simple()
                    .textContent('✅ Bumped to v' + higherTpl.templateVersion + ' (' + higherTpl.templateStatus + ')')
                    .position('top right')
                    .hideDelay(2500)
            );
        });
    };

    $scope.canBumpDownVersion = function (env, index) {
        if (!$scope.workflowEditMode) return false;
        if (!env || !env.templateInstanceVersion) return false;

        var allowed = getTemplatesAllowedForBump(env);
        var lowerTpl = getImmediateLowerTemplate(allowed, env.templateInstanceVersion);
        if (!lowerTpl) return false;

        var prev = $scope.getPrevEnv(index);
        if (prev && prev.templateInstanceVersion) {
            if (compareVersions(prev.templateInstanceVersion, lowerTpl.templateVersion) < 0) return false;
        }

        var next = $scope.getNextEnv(index);
        if (next && next.templateInstanceVersion) {
            if (compareVersions(lowerTpl.templateVersion, next.templateInstanceVersion) < 0) return false;
        }

        return true;
    };

    $scope.bumpDownTemplateVersion = function (env, index) {
        if (!$scope.canBumpDownVersion(env, index)) return;

        var allowed = getTemplatesAllowedForBump(env);
        var lowerTpl = getImmediateLowerTemplate(allowed, env.templateInstanceVersion);
        if (!lowerTpl) return;

        return applyValidatedVersionChange(env, index, lowerTpl, $scope.canBumpDownVersion, function () {
            // ✅ Guardar estado anterior
            var previousStatus = env.templateInstanceStatus;
            var wasDisabled = !env.isEnabled;

            env.selectedTemplateId = lowerTpl.id;
            env.templateInstanceId = lowerTpl.id;
            env.templateInstanceStatus = lowerTpl.templateStatus;
            env.templateInstanceVersion = lowerTpl.templateVersion;

            // ✅ Lógica de auto-enable/disable
            if (lowerTpl.templateStatus !== 'PUBLISHED' && env.isEnabled) {
                // Deshabilitar si NO es PUBLISHED y estaba habilitado
                env.isEnabled = false;
                console.log('⚠️ Auto-disabled', env.name, '(non-PUBLISHED template:', lowerTpl.templateStatus + ')');
            } else if (lowerTpl.templateStatus === 'PUBLISHED' && wasDisabled && previousStatus !== 'PUBLISHED') {
                // ✅ HABILITAR si pasa de DRAFT/otro a PUBLISHED y estaba disabled
                env.isEnabled = true;
                console.log('✅ Auto-enabled', env.name, '(downgraded to PUBLISHED)');

                $mdToast.show(
                    $mdToast.simple()
                        .textContent('✅ Environment auto-enabled (now using PUBLISHED template)')
                        .position('top right')
                        .hideDelay(3000)
                );
            }

            updateWorkflowChangesFlag();
            triggerVersionAnim(env, 'down');

            $mdToast.show(
                $mdToast.simple()
                    .textContent('✅ Bumped down to v' + lowerTpl.templateVersion + ' (' + lowerTpl.templateStatus + ')')
                    .position('top right')
                    .hideDelay(2500)
            );
        });
    };

    function triggerVersionAnim(env, kind) {
        if (!env) return;

        env._versionAnim = null;

        $timeout(function () {
            env._versionAnim = kind;

            $timeout(function () {
                env._versionAnim = null;
            }, 650);
        }, 0);
    }

    // ============================================
    // ROLL UP VERSIONS
    // ============================================

    $scope.canRollUp = function () {
        return $scope.sortedEnvironments.some(function (env) {
            return env.envType.toString().toUpperCase() === 'DEVELOPMENT' &&
                env.templateInstanceStatus === 'PUBLISHED';
        });
    };

    function validateAndApplyRoll(plan) {
        if (!$scope.workflowEditMode || $scope.assignmentChecksPending) return;
        var environments = $scope.sortedEnvironments;
        var before = JSON.stringify(environments);
        var proposal = angular.copy(environments);
        if (!plan(proposal)) return;
        var profileId = $scope.profile && $scope.profile.id;
        if (!profileId) return;

        $scope.assignmentChecksPending++;
        // The backend checks every resulting assignment without changing persisted state.
        return ProfileService.checkEnvironmentAssignments(profileId, proposal.filter(function (env) {
            return !!env.id;
        }).map(function (env) {
            return { id: env.id, templateInstanceId: env.templateInstanceId || null };
        })).then(function (response) {
            if (!response.data || response.data.allowed !== true) {
                $scope.showWorkflowError((response.data && response.data.reason) ||
                    'Could not verify resource reconciliation. Please retry.');
                return;
            }
            if (!$scope.workflowEditMode || !$scope.profile || $scope.profile.id !== profileId ||
                $scope.sortedEnvironments !== environments || JSON.stringify(environments) !== before) return;

            proposal.forEach(function (env, index) {
                ['selectedTemplateId', 'templateInstanceId', 'templateInstanceStatus',
                    'templateInstanceVersion', 'isEnabled'].forEach(function (field) {
                    environments[index][field] = env[field];
                });
            });
            $scope.updateAllSequences();
            updateWorkflowChangesFlag();
            $mdToast.show($mdToast.simple().textContent('✅ Workflow versions updated.')
                .position('top right').hideDelay(3000));
        }, function (error) {
            var data = error && error.data;
            $scope.showWorkflowError((data && (data.reason || data.message)) ||
                'Could not verify resource reconciliation. Please retry.');
        }).finally(function () {
            $scope.assignmentChecksPending--;
        });
    }

    $scope.rollUpVersions = function () {
        return validateAndApplyRoll(planRollUp);
    };

    function planRollUp(envs) {
        var isUpdated = false;

        for (var i = envs.length - 1; i >= 0; i--) {
            var currentEnv = envs[i];
            var prevEnv = envs[i - 1];

            if (isProtectedEnvType(currentEnv.envType)) {
                continue;
            }

            if (currentEnv.envType.toString().toUpperCase() === 'DEVELOPMENT') {
                var higherTemplate = getImmediateHigherTemplate($scope.availableTemplates, currentEnv.templateInstanceVersion);

                if (higherTemplate) {
                    // ✅ Guardar estado anterior
                    var previousStatus = currentEnv.templateInstanceStatus;
                    var wasDisabled = !currentEnv.isEnabled;

                    currentEnv.templateInstanceVersion = higherTemplate.templateVersion;
                    currentEnv.selectedTemplateId = higherTemplate.id;
                    currentEnv.templateInstanceId = higherTemplate.id;
                    currentEnv.templateInstanceStatus = higherTemplate.templateStatus;

                    // ✅ Lógica de auto-enable/disable
                    if (higherTemplate.templateStatus !== 'PUBLISHED' && currentEnv.isEnabled) {
                        currentEnv.isEnabled = false;
                    } else if (higherTemplate.templateStatus === 'PUBLISHED' && wasDisabled && previousStatus !== 'PUBLISHED') {
                        currentEnv.isEnabled = true;
                    }

                    isUpdated = true;
                }
            } else {
                if (prevEnv && prevEnv.templateInstanceVersion) {
                    // ✅ Guardar estado anterior
                    var previousStatus = currentEnv.templateInstanceStatus;
                    var wasDisabled = !currentEnv.isEnabled;

                    currentEnv.templateInstanceVersion = prevEnv.templateInstanceVersion;
                    currentEnv.selectedTemplateId = prevEnv.selectedTemplateId || prevEnv.templateInstanceId;
                    currentEnv.templateInstanceId = prevEnv.templateInstanceId;
                    currentEnv.templateInstanceStatus = prevEnv.templateInstanceStatus;

                    // ✅ Lógica de auto-enable/disable
                    if (prevEnv.templateInstanceStatus !== 'PUBLISHED' && currentEnv.isEnabled) {
                        currentEnv.isEnabled = false;
                    } else if (prevEnv.templateInstanceStatus === 'PUBLISHED' && wasDisabled && previousStatus !== 'PUBLISHED') {
                        currentEnv.isEnabled = true;
                    }

                    isUpdated = true;
                }
            }
        }

        return isUpdated;
    }

    // ============================================
    // ROLL DOWN (placeholder)
    // ============================================

    $scope.canRollDown = function () {
        if (!$scope.sortedEnvironments || $scope.sortedEnvironments.length === 0) return false;

        var lastEligible = null;
        for (var i = $scope.sortedEnvironments.length - 1; i >= 0; i--) {
            if (!isProtectedEnvType($scope.sortedEnvironments[i].envType)) {
                lastEligible = $scope.sortedEnvironments[i];
                break;
            }
        }

        if (!lastEligible || !lastEligible.templateInstanceVersion) return false;

        var allowed = getTemplatesAllowedForBump(lastEligible);
        return !!getImmediateLowerTemplate(allowed, lastEligible.templateInstanceVersion);
    };

    $scope.rollDownWorkflow = function () {
        return validateAndApplyRoll(planRollDown);
    };

    function planRollDown(envs) {
        var isUpdated = false;

        // Encontrar el índice del último ambiente elegible (no PRODUCTION)
        var lastEligibleIndex = -1;
        for (var i = envs.length - 1; i >= 0; i--) {
            if (envs[i].envType.toString().toUpperCase() !== 'PRODUCTION') {
                lastEligibleIndex = i;
                break;
            }
        }

        if (lastEligibleIndex === -1) return false;

        // Iterar de izquierda a derecha, excluyendo DEVELOPMENT y PRODUCTION
        for (var i = 0; i < lastEligibleIndex; i++) {
            var currentEnv = envs[i];
            var nextEnv = envs[i + 1];

            // Igual que roll-up excluye PRODUCTION, roll-down excluye DEVELOPMENT y PRODUCTION
            if (currentEnv.envType.toString().toUpperCase() === 'DEVELOPMENT') {
                continue;
            }
            if (currentEnv.envType.toString().toUpperCase() === 'PRODUCTION') {
                continue;
            }

            if (nextEnv && nextEnv.templateInstanceVersion) {
                var previousStatus = currentEnv.templateInstanceStatus;
                var wasDisabled = !currentEnv.isEnabled;

                currentEnv.templateInstanceVersion = nextEnv.templateInstanceVersion;
                currentEnv.selectedTemplateId = nextEnv.selectedTemplateId || nextEnv.templateInstanceId;
                currentEnv.templateInstanceId = nextEnv.templateInstanceId;
                currentEnv.templateInstanceStatus = nextEnv.templateInstanceStatus;

                if (nextEnv.templateInstanceStatus !== 'PUBLISHED' && currentEnv.isEnabled) {
                    currentEnv.isEnabled = false;
                } else if (nextEnv.templateInstanceStatus === 'PUBLISHED' && wasDisabled && previousStatus !== 'PUBLISHED') {
                    currentEnv.isEnabled = true;
                }

                isUpdated = true;
            }
        }

        // Bump-down en el último ambiente elegible (no PRODUCTION)
        var lastEligible = envs[lastEligibleIndex];
        if (lastEligible && lastEligible.templateInstanceVersion) {
            var allowed = getTemplatesAllowedForBump(lastEligible);
            var lowerTpl = getImmediateLowerTemplate(allowed, lastEligible.templateInstanceVersion);

            if (lowerTpl) {
                var previousStatus = lastEligible.templateInstanceStatus;
                var wasDisabled = !lastEligible.isEnabled;

                lastEligible.selectedTemplateId = lowerTpl.id;
                lastEligible.templateInstanceId = lowerTpl.id;
                lastEligible.templateInstanceStatus = lowerTpl.templateStatus;
                lastEligible.templateInstanceVersion = lowerTpl.templateVersion;

                if (lowerTpl.templateStatus !== 'PUBLISHED' && lastEligible.isEnabled) {
                    lastEligible.isEnabled = false;
                } else if (lowerTpl.templateStatus === 'PUBLISHED' && wasDisabled && previousStatus !== 'PUBLISHED') {
                    lastEligible.isEnabled = true;
                }

                isUpdated = true;
            }
        }

        return isUpdated;
    }

    $scope.openTemplateExplorer = function (env) {
        if (!env.templateInstanceId) return;

        TemplateInstanceService.getTemplateInstanceById(env.templateInstanceId)
            .then(function (response) {
                $mdDialog.show({
                    controller: 'TreeTemplateViewController',
                    templateUrl: 'template/treeView/tree-template-view.html',
                    parent: angular.element(document.body),
                    escapeToClose: false,
                    clickOutsideToClose: true,
                    multiple: true,
                    locals: {
                        templateInstance: response.data
                    }
                });
            })
            .catch(function (err) {
                console.error('[openTemplateExplorer] Error loading templateInstance:', env.templateInstanceId, err);
                dialogService.showErrorDialog(
                    'Error Loading Template',
                    'Failed to load template instance. ' + (err.data && err.data.message ? err.data.message : err.message || 'Unknown error')
                );
            });
    };

    // Índice del tab de Environments en el dialog de profile
    var ENV_TAB_INDEX = 1;

    $scope.$on('profile:tabActivated', function (event, tabIndex) {
        if (tabIndex !== ENV_TAB_INDEX) return;
        console.log('🔄 Environments tab activated — refreshing available templates and agent statuses');
        $scope.loadAvailableTemplates();
        // En edición, re-ordenar desde el profile descartaría los cambios sin salvar.
        if (!$scope.workflowEditMode) {
            $scope.sortEnvironmentsBySequence();
        }
        $scope.refreshAgentStatuses();
    });

    // EnvWorkflowViewer.js — reemplazar el $on existente
    $scope.$on('template:refreshEnvTemplates', function () {
        console.log('🔄 Template status changed — refreshing available templates');
        $scope.loadAvailableTemplates();
    });

});